import type { Strings } from './strings.js';

export const it: Strings = {
  languageName: 'Italiano',
  welcome: 'Benvenuti',
  chooseReason: 'Come possiamo aiutarla?',
  back: 'Indietro',
  cancel: 'Annulla',
  next: 'Avanti',
  submit: 'Invia registrazione',
  submitting: 'Invio in corso',
  yourDetails: 'I suoi dati',
  optional: 'facoltativo',
  required: 'campo obbligatorio',
  requiredHint: 'Compili i campi evidenziati.',
  fieldRequired: 'Compili questo campo.',
  fieldInvalid: 'Controlli questo dato.',
  pleaseSelect: 'Selezioni',
  search: 'Cerca',
  noResults: 'Nessun risultato',
  noOptions: 'Al momento qui non è disponibile alcuna opzione. Si rivolga a un collaboratore.',
  stepReason: 'Motivo della visita',
  stepDetails: 'Dati',
  stepDone: 'Fatto',
  thankYou: 'Grazie!',
  submitted: 'La sua registrazione è stata inviata.',
  waitHint: 'Prenda posto. Verrà chiamato a breve.',
  scanFormHint: 'Scansioni il codice con il telefono per portare con sé il modulo.',
  ticketNumber: 'Il suo numero di attesa è',
  queuedTitle: 'Grazie!',
  queuedHint: 'La sua registrazione è stata salvata e verrà inviata automaticamente. Prenda posto.',
  errorTitle: 'Purtroppo non ha funzionato',
  errorHint: 'Riprovi o si rivolga a un collaboratore.',
  tryAgain: 'Riprova',
  startOver: 'Ricomincia',
  closedTitle: 'La nostra amministrazione è attualmente chiusa',
  closedHint: 'Può registrarsi comunque - la ricontatteremo il prossimo giorno lavorativo.',
  closedCallUs: 'Può contattarci telefonicamente al numero',
  continueAnyway: 'Registrati comunque',
  appointmentQuestion: 'Ha un appuntamento?',
  appointmentYes: 'Sì, ho un appuntamento',
  appointmentNo: 'No, non ho un appuntamento',
  visitingWhom: 'Chi desidera visitare?',
  privacyTitle: 'Protezione dei dati',
  privacyAccept: "Ho letto l'informativa sulla privacy.",
  privacyRequired: "Confermi l'informativa sulla privacy.",
  offline: 'Offline',
  offlineHint: 'Nessuna connessione - le registrazioni vengono salvate e inviate più tardi.',
  pendingCount: 'registrazioni salvate',
  idleWarning: 'I suoi dati verranno eliminati a breve.',
  pairTitle: 'Collega il tablet',
  pairHint: "Inserisca il codice di accoppiamento fornito dall'amministrazione.",
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Collega',
  pairError: 'Il codice non è valido o è scaduto.',
  pairSuccess: 'Tablet collegato',
  loading: 'Caricamento',
  notConfigured: 'Nessun tipo di visita configurato',
  notConfiguredHint: 'Si rivolga a un collaboratore.',
  adminLink: 'Amministrazione',
  pairCodeHint:
    'Il codice viene generato nell’amministrazione in “Sedi e tablet” ed è valido solo per un tempo limitato.',
  setupTitle: 'Non ancora configurato',
  setupText:
    'Questo sistema non è ancora stato configurato. La procedura guidata crea l’amministratore, l’organizzazione, una sede e il primo tablet.',
  setupButton: 'Avvia la configurazione',
  setupAfter: 'Subito dopo comparirà qui il campo per il codice di abbinamento.',
};
